/**
 * Phase 35 — one metric of a scope: its words, its sparkline, and the chip
 * that puts the offered number in the card (when there are enough days).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenHistoryScope, DropGenHistoryStat, DropGenHistorySuggestion } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { CHOICE_CHIP, CHOICE_OFF } from '../../general/controls/field-style';
import { chipLabel, dayWords, statWords } from './history-words';
import { Sparkline } from './Sparkline';

export type SuggestionKind = keyof DropGenHistoryScope['suggested'];

export const StatRow: FC<{
  scope: DropGenHistoryScope;
  stat: DropGenHistoryStat;
  which: SuggestionKind;
  onUse: (s: DropGenHistorySuggestion) => void;
}> = ({ scope, stat, which, onUse }) => {
  const offered = scope.suggested[which].filter((s) => s.metric === stat.metric);
  const values = scope.days.map((d) => d.values[stat.metric]).filter((v): v is number => v !== undefined);
  return (
    <span className="flex flex-wrap items-center gap-x-2 gap-y-1" data-testid={`history-${stat.metric}`}>
      <Sparkline values={values} title={dayWords(stat.metric, scope.days)} className="text-muted-foreground/70" />
      <span>{statWords(stat)}</span>
      {offered.map((s) => (
        <button key={`${s.op}${s.value}`} type="button" title={s.words} onClick={() => onUse(s)} className={cn(CHOICE_CHIP, CHOICE_OFF, 'h-6 px-2 text-[11px]')}>
          {chipLabel(s)}
        </button>
      ))}
    </span>
  );
};
